import React from 'react';

//Styles
import styles from '../Profile.module.scss';

import { SocialNetwork, User } from '../../../global';
import { dateFromISOString } from '../../../helpers/stringUtils';
import SocialIcon from '../../../components/SocialIcon/SocialIcon';
import ProfileColumn from './components/ProfileColumn';

interface Props {
  user: User;
  loggedUser: User | null;
  setBreadcrumbs: (breadcrumbs: string) => void;
  setPopupMessage: (message: boolean) => void;
}

const ProfileWLF: React.FC<Props> = ({ user, loggedUser, setPopupMessage }) => {

  return (
    <div className="bg-light-gray px-md-0 ">
      <main className={`${styles.profileWrapper}  container pt-5 mb-5 px-sm-0  overflow-hidden `}>
        <div className={`row  `}>
          {/* Left column  ====================================================== */}
          <ProfileColumn user={user} />

          <div className="col-12 col-md-9 ">
            <div className="row">
              <div className="col-12 ps-4 ps-sm-5">
                {user.visibleName && (
                  <div className="row mb-5 ">
                    <div className="col-12 col-md-2 text text-left mb-2 fw-bold">Name</div>
                    <div className="col-12 col-md-10">{user.visibleName}</div>
                  </div>
                )}
                {user.companyName && (
                  <div className="row mb-5 ">
                    <div className="col-12 col-md-2 text text-left mb-2 fw-bold">Company</div>
                    <div className="col-12 col-md-10">{user.companyName}</div>
                  </div>
                )}
                {user.sector && (
                  <div className="row mb-5 ">
                    <div className="col-12 col-md-2 text text-left mb-2 fw-bold">Sector</div>
                    <div className="col-12 col-md-10">{user.sector}</div>
                  </div>
                )}

                {user.hasPublicBirthDate && user.birthDate && (
                  <div className="row mb-5 ">
                    <div className="col-12 col-md-2 text text-left mb-2 fw-bold">BirthDate</div>
                    <div className="col-12 col-md-10">{dateFromISOString(user.birthDate)}</div>
                  </div>
                )}
                {user.description && (
                  <div className="row mb-5 ">
                    <div className="col-12 col-md-2 text text-left mb-2 fw-bold">Description</div>
                    <div className="col-12 col-md-10">{user.description}</div>
                  </div>
                )}
                {user.biography && (
                  <div className="row mb-5">
                    <div className="col-12 col-md-2 text text-left mb-2 fw-bold">Biography</div>
                    <div className="col-12 col-md-10">
                      <p>{user.biography}</p>
                    </div>
                  </div>
                )}
                {user.school1 && user.hasPublicFirstSchool && (
                  <div className="row mb-5">
                    <div className="col-12 col-md-2 text text-left mb-2 fw-bold">School</div>
                    <div className="col-12 col-md-10">{user?.school1}</div>
                  </div>
                )}
                {user?.school2 && user.hasPublicSecondSchool && (
                  <div className="row mb-5">
                    <div className="col-12 col-md-2 text text-left mb-2 fw-bold">School</div>
                    <div className="col-12 col-md-10">{user?.school2}</div>
                  </div>
                )}
                {user.gender && (
                  <div className="row mb-5">
                    <div className="col-12 col-md-2 text text-left mb-2 fw-bold">Gender</div>
                    <div className="col-12 col-md-10">{user.gender === 'M' ? 'He/Him' : user.gender === 'F' ? 'She/Her' : user.gender === 'N' ? 'N/A' : 'other'}</div>
                  </div>
                )}
                {user.socialNetworks && user.socialNetworks.length > 0 && (
                  <div className="row mb-5">
                    <div className="col-12 col-md-2 text text-left mb-2 fw-bold">Social networks</div>
                    <div className="col-12 col-md-10 d-flex flex-row align-items-center">
                      {user.socialNetworks.map((item: SocialNetwork, index: number) => (
                        <SocialIcon socialNetwork={item} key={index} />
                      ))}
                    </div>
                  </div>
                )}
                {user.website && (
                  <div className="row mb-5">
                    <div className="col-12 col-md-2 text text-left mb-2 fw-bold">Website</div>
                    <div className="col-12 col-md-10">
                      <a href={user.website} target="_blank" rel="noreferrer">
                        {user.website}
                      </a>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
      {/* <AppFooter links={footerMenu} bgColor="#304053" logoImg={headerLogo} bgImage={footerImg} /> */}
    </div>
  );
};

export default ProfileWLF;
